import styled from 'styled-components';
import { connect } from '@ardoq/rxbeach';
import { GhostButton, TertiaryButton } from '@ardoq/button';
import type { Column } from '@ardoq/table-legacy';
import { ErrorNotification } from '@ardoq/status-ui';
import { s16, s8 } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { Connection } from '@ardoq/api-types/integrations';
import { ConnectionsAsyncOperationsState } from 'integrations/common/streams/connections/types';
import { ConnectionsTable } from 'integrations/common/components/connectionsTable/ConnectionsTable';
import { viewModel$ } from './viewModel$';
import type { I18nLocale } from '@ardoq/i18n';

type ConnectionsParams = {
  statuses: ConnectionsAsyncOperationsState;
  connections: Connection[];
  isAdmin: boolean;
  onDelete: (connection: Connection) => void;
  onUpsertClick: (connection?: Connection) => void;
  onRefresh: () => void;
  onConnectionClick: (connection: Connection) => void;
  extraColumns?: Column<Connection>[];
  connectYourAccountTitle: string;
  connectYourAccountBtn: string;
  refreshButtonLabel: string;
  createNewConnectionLabel: string;
  i18nLocale: I18nLocale;
};

const ButtonContainer = styled(FlexBox).attrs({
  justify: 'flex-end',
  gap: 'medium',
})`
  margin-bottom: ${s16};
  width: 100%;
`;

const ConnectionsComponent = ({
  connections,
  statuses,
  isAdmin,
  onDelete,
  onUpsertClick,
  onRefresh,
  onConnectionClick,
  extraColumns = [],
  connectYourAccountTitle,
  connectYourAccountBtn,
  refreshButtonLabel,
  createNewConnectionLabel,
  i18nLocale,
}: ConnectionsParams) => {
  const { status: listStatus, message: listMessage } = statuses.list;
  const isListFailure = listStatus === 'FAILURE';
  return (
    <>
      {isListFailure && (
        <ErrorNotification style={{ alignItems: 'center', marginBottom: s8 }}>
          <FlexBox justify="space-between" align="center" gap="medium">
            {listMessage}
            <GhostButton onClick={onRefresh}>{refreshButtonLabel}</GhostButton>
          </FlexBox>
        </ErrorNotification>
      )}
      {isAdmin &&
        connections.length > 0 && (
          // Temporary for old design compatibility. We should remove this when we remove old design
          <ButtonContainer paddingRight="medium">
            <TertiaryButton onClick={() => onUpsertClick()}>
              {createNewConnectionLabel}
            </TertiaryButton>
          </ButtonContainer>
        )}
      <ConnectionsTable
        connections={connections}
        listStatus={listStatus}
        isAdmin={isAdmin}
        onDelete={onDelete}
        onUpsertClick={onUpsertClick}
        onConnectionClick={onConnectionClick}
        extraColumns={extraColumns}
        connectYourAccountTitle={connectYourAccountTitle}
        connectYourAccountBtn={connectYourAccountBtn}
        i18nLocale={i18nLocale}
      />
    </>
  );
};

export const Connections = connect(ConnectionsComponent, viewModel$);
